import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.el.classList.add('u-split-text')

        this.delay = this.getData('delay') || 0
        this.hasAnimated = false;

        // Set events and such
        this.setSplit();

        this.resizeBind = this.setSplit.bind(this);
        window.addEventListener('resize', this.resizeBind);
    }

    setSplit() {
        if(this.split && this.split.revert)
            this.split.revert()

        this.split = new SplitText(this.el, { type: 'lines,words' })

        requestAnimationFrame(() => {
            this.$words = this.el.querySelectorAll('div > div')
            this.$words.length && this.$words[0].classList.add('-first-word')

            if(this.hasAnimated) {
                gsap.to(this.$words, {
                    duration: 0,
                    y: 0,
                    force3D: true,
                    opacity: 1,
                    delay: 0,
                    ease: Power3.easeOut,
                    stagger: 0,
                    onStart: () => {
                        this.el.classList.add('is-animating')
                    },
                    onComplete: () => {
                        this.hasAnimated = true;
                    }
                })
            }
        })
    }

    playAnime() {
        requestAnimationFrame(() => {

            if (!this.$words) {

                setTimeout(() => {
                    if (!this.$words) return
                    this.anime()
                }, 100)

            }

            this.anime()
        })
    }

    resetStyles() {
        if (!this.$words) return
        gsap.set(this.$words, {
            y: '120%',
            opacity: 0
        });
    }

    anime(duration = 0.8) {
        gsap.to(this.$words, {
            duration: duration,
            y: 0,
            force3D: true,
            opacity: 1,
            delay: this.delay,
            ease: Power3.easeOut,
            stagger: .01,
            onStart: () => {
                this.el.classList.add('is-animating')
            },
            onComplete: () => {
                this.hasAnimated = true;
            }
        })
    }

    destroy() {
        super.destroy();
        window.removeEventListener('resize', this.resizeBind);
    }
}
